import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	saveFilterButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	saveFilterDialogTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	copyFilterButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	copyFilterDialogTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	saveFilterButton: {
		id: 'issue-navigator.jql-builder.save-filter-button',
		defaultMessage: 'Save filter',
		description: 'Text for the button to open save filter modal.',
	},
	saveFilterDialogTitle: {
		id: 'issue-navigator.jql-builder.save-filter-dialog-title',
		defaultMessage: 'Save filter',
		description: 'Text for title of save filter modal.',
	},
	copyFilterButton: {
		id: 'issue-navigator.jql-builder.copy-filter-button',
		defaultMessage: 'Copy filter',
		description: 'Text for the button to open copy filter modal.',
	},
	copyFilterDialogTitle: {
		id: 'issue-navigator.jql-builder.copy-filter-dialog-title',
		defaultMessage: 'Copy filter',
		description: 'Text for title of copy filter modal.',
	},
});
export default messages;
